module.exports = __webpack_public_path__ + "static/VMU_Bezel-b2416005365b220c3dfa81c6535eba65.png";